import { render, staticRenderFns } from "./QuantityCol.vue?vue&type=template&id=609239a8&scoped=true"
import script from "./QuantityCol.vue?vue&type=script&lang=js"
export * from "./QuantityCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609239a8",
  null
  
)

export default component.exports